.CRModal
    position: fixed
    top: 0
    left: 0
    right: 0
    bottom: 0
    background: rgb($globalSettingsFontPrimary)
    cursor: pointer
    z-index: $indexOverlay
    animation: 0.2s ease-in-out 0s 1 openCRModal
    animation-fill-mode: forwards
    opacity: 0

@keyframes openCRModal
    0%
        opacity: 0
    100%
        opacity: 0.6

.CRWrapper
    color: rgb($globalSettingsFontPrimary)
    position: fixed
    width: calc(100% - 20px)
    max-width: 740px
    min-height: 0
    max-height: calc(100% - 20px)
    left: calc(50% - 10px)
    top: calc(50% - 10px)
    transform: translate(-50%, -50%)
    background-color: rgb($globalSettingsBackgroundPrimary)
    margin: 10px
    padding: 20px 0
    box-sizing: border-box
    z-index: $indexDetails
    border-radius: $globalSettingsRoundingLarge
    display: flex
    flex-direction: column
    overflow: hidden
    @media #{$mobile}
        left: 5px
        right: 5px
        top: 5px
        bottom: 5px
        width: unset
        max-width: unset
        height: unset
        max-height: unset
        border-radius: $globalSettingsRounding
        transform: translate(0, 0)
